export default __webpack_public_path__ + "static/media/program.d7a86b5c.svg";